import { EntityProfilePlaceholderTab } from '@features/Shared/EntityProfile/EntityProfilePlaceholderTab'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslations } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/framework/forestowner/$forestownerId/economy')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Økonomi',
  },
})

function RouteComponent() {
  const { t } = useTranslations()
  return (
    <EntityProfilePlaceholderTab
      title={t('forestowner-search-overview.tabs.economy')}
      description={t('framework-forestownersandbox.placeholderDescription')}
    />
  )
}
